/* eslint-disable @typescript-eslint/no-explicit-any */
import { MAP_STATUS, MapKeys, GLOBAL_MAP_DETIALS, } from "../../store/common/constants";
import { getDraftState } from "../../api/venues";
import IndoorHelper from "../../store/helpers/indoorHelper";
export var getMapstatus = function (features) {
    return (features === null || features === void 0 ? void 0 : features.length) < 1
        ? MAP_STATUS[MapKeys.IN_CREATION].VALUE
        : MAP_STATUS[MapKeys.READY].VALUE;
};
export var getMapData = function (currentMapOnThePage, mapOptions) {
    var token = mapOptions.token, env = mapOptions.env, user = mapOptions.user;
    var draftMapObj = {};
    for (var _i = 0, currentMapOnThePage_1 = currentMapOnThePage; _i < currentMapOnThePage_1.length; _i++) {
        var currentMap = currentMapOnThePage_1[_i];
        // if there is draft status then check for checkedin/checkout
        if ((currentMap === null || currentMap === void 0 ? void 0 : currentMap.isDraft) && !(currentMap === null || currentMap === void 0 ? void 0 : currentMap.draftStatus)) {
            draftMapObj[currentMap === null || currentMap === void 0 ? void 0 : currentMap.id] = getDraftState(token, IndoorHelper.formatDraftHrn((env === null || env === void 0 ? void 0 : env.environmentId) === "prod" ? "here" : "here-dev", user === null || user === void 0 ? void 0 : user.realm, currentMap.id));
        }
    }
    return { draftMapObj: draftMapObj };
};
export var getDraftStatus = function (status) {
    return status === MAP_STATUS[MapKeys.CHECKED_OUT].VALUE
        ? MAP_STATUS[MapKeys.CHECKED_OUT].LABEL
        : MAP_STATUS[MapKeys.CHECKED_IN].LABEL;
};
export var getMapState = function (state, modifiedDate, createdDate) {
    return state === MAP_STATUS[MapKeys.CHECKED_OUT].VALUE
        ? modifiedDate === createdDate
            ? MAP_STATUS[MapKeys.IN_CREATION].LABEL
            : MAP_STATUS[MapKeys.PENDING_UPDATE].LABEL
        : MAP_STATUS[MapKeys.READY].LABEL;
};
export var getButtonText = function (status) {
    return status === MAP_STATUS[MapKeys.CHECKED_OUT].VALUE
        ? GLOBAL_MAP_DETIALS.EDIT_MAP
        : GLOBAL_MAP_DETIALS.VIEW_MAP;
};
